export default {
  state: { data: {} },
  mutations: {
    setAmortCompAndTALCData(state, data) {
      state.data = data;
    }
  },
  actions: {}
};
